module.exports = __webpack_public_path__ + "static/002-09e94f15190c5ade341cb1db939aac3e.png";